import { hash } from '../../Hash/dist/effect-Hash.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const symbol = /*#__PURE__*/Symbol.for("effect/Equal");

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category equality
 */

function equals() {
  if (arguments.length === 1) {
    return self => compareBoth(self, arguments[0]);
  }
  return compareBoth(arguments[0], arguments[1]);
}
function compareBoth(self, that) {
  if (self === that) {
    return true;
  }
  const selfType = typeof self;
  if (selfType !== typeof that) {
    return false;
  }
  if ((selfType === "object" || selfType === "function") && self !== null && that !== null) {
    if (isEqual(self) && isEqual(that)) {
      return hash(self) === hash(that) && self[symbol](that);
    }
  }
  return false;
}

/**
 * @since 2.0.0
 * @category guards
 */
const isEqual = u => typeof u === "object" && u !== null && symbol in u;

/**
 * @since 2.0.0
 * @category instances
 */
const equivalence = () => (self, that) => equals(self, that);

export { equals, equivalence, isEqual, symbol };
